import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { InboxPouchService } from './inbox.pouchdb.service';
import { first } from 'rxjs/operators';
import { Constants } from '../../shared/models/constants';
import * as _ from 'lodash';
import { InboxBids } from '../../shared/models/inboxBids';
import { InboxBookData } from '../../shared/models/inboxBookData';
import { Http, Response, RequestOptions, Headers, RequestOptionsArgs } from '@angular/http';
@Component({
    selector: 'app-inbox',
    templateUrl: './inbox.component.html',
    styleUrls: ['./inbox.component.css']
})
export class InboxComponent implements OnInit {
    @Input() exportData: any
    @Input() selectedLibOptInd: any;
    @Output() inboxEvent = new EventEmitter<any>();
    state;
    public bookid: any;
    public uniqBooksArray;
    public formedBooksArr = [];
    public inboxBids: any;
    inboxDataSubscription: any;
    constructor(public inboxService: InboxPouchService, private http: Http) { }
    contactList = [];
    public localExportDataWithBids: any;
    ngOnInit() {

        if (this.exportData) {

        }

        else {
            this.exportData = []
        }

        this.localExportDataWithBids = [];
        // this.shelfsevice.getExportDetails();
    }

    loadInboxContent(data) {

        this.inboxEvent.emit(data);

    }

    bookdataResult: any;

    public timestampArray: any;

    ngOnChanges(changes: SimpleChanges) {
        var self = this;

        // if (this.selectedLibOptInd == 1 && this.exportData.length) {
        //     this.loadInboxContent(this.exportData[0]);
        // }

        if (changes.exportData) {
            if (changes.exportData.currentValue) {



                this.exportData = changes.exportData.currentValue;

                var inboxBidsObj = changes.exportData.currentValue.inboxBidsObject;
                var exportedObject = changes.exportData.currentValue.exportedObject;

                if (exportedObject) {

                    if (inboxBidsObj && exportedObject.length > 0) {

                        this.inboxService.prepareExportDataObject(inboxBidsObj, exportedObject).then(function (exoprtArray) {
                            self.timestampArray = exoprtArray;

                            self.timestampArray.reverse();
                            self.localExportDataWithBids = self.timestampArray;

                            if (self.selectedLibOptInd == 1 && self.localExportDataWithBids.length > 0) self.loadInboxContent(self.localExportDataWithBids[0]);

                        });
                    }

                    else {
                        var arr = [];
                        if (self.selectedLibOptInd == 1) self.loadInboxContent(arr);

                    }

                }

                else {
                    var arr = [];
                    if (self.selectedLibOptInd == 1) self.loadInboxContent(arr);

                }


                // this.prepareExportDataObject(changes.exportData.currentValue.inboxBidsObject, changes.exportData.currentValue.exportedObject);

                const headers = new Headers();
                headers.append('Authorization', 'Bearer' + localStorage.userToken);
                const options = new RequestOptions({ headers: headers });
                var self = this;

                this.http.post(
                    "http://" + Constants.nasUrl, {
                        "query": 'query{ appPremissions, {directExport, organizationId,  appFeatures,{ id, featuresType}contacts{user, { id, name, type, email }} }}',
                    }, options
                ).subscribe(
                    res =>
                        self.GetContactList(res.json().data)
                );
            }
        }


    }


    GetContactList(contact) {
        if (contact.appPremissions) {
            this.contactList = contact.appPremissions.contacts;
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/shelf/inbox/inbox.component.ts